var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import moment from 'moment-timezone';
export function transformReadInstrumentsArg(_a) {
    var _b, _c, _d, _e, _f;
    var { id } = _a, body = __rest(_a, ["id"]);
    return Object.assign(Object.assign({}, body), { settings: Object.assign(Object.assign({}, body.settings), { timezone: (_c = (_b = body.settings) === null || _b === void 0 ? void 0 : _b.timezone) !== null && _c !== void 0 ? _c : moment.tz.guess(), locale: (_e = (_d = body.settings) === null || _d === void 0 ? void 0 : _d.locale) !== null && _e !== void 0 ? _e : moment.locale() }), meta: Object.keys((_f = body.meta) !== null && _f !== void 0 ? _f : {}).length ? body.meta : undefined });
}
